// removed by extract-text-webpack-plugin
module.exports = {"nffs-solicitation-code-definition-tooltip":"nffs-solicitation-code-definition-tooltip"};


//////////////////
// WEBPACK FOOTER
// ./src/components/grids/SolicitationsGrid/subcomponents/CustomCell/Cell.scss
// module id = 4925
// module chunks = 1